export const apiKey = 'AIzaSyC50su3hMkFmmeRUo_eLj7cVjQNMgfSPpE'
export const authDomain = 'discover-mexico.firebaseapp.com'
export const projectId = 'discover-mexico'
export const storageBucket = 'discover-mexico.appspot.com'
export const messagingSenderId = '157583324638'
export const appId = '1:157583324638:web:0965913748689cbd68594f'
export const measurementId = 'G-WWSMRYPB3R'
